import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../../../actions/authentication';
import { getOfferFromHistory } from '../../../../actions/offersHistory';
import { selectActiveOfferId } from '../../../../selectors/offersHistory';

/**
 * Возвращает коллбэк, который используется для кнопки "Войдите" в компоненте AuthError.
 * Вызывает попап авторизации и по успеху загружает активный оффер
 * */
export const useHandleResolveAuthError = () => {
  const dispatch = useDispatch();
  const activeOfferId = useSelector(selectActiveOfferId);

  return React.useCallback(() => {
    let onSuccess;

    if (activeOfferId) {
      onSuccess = () => getOfferFromHistory({ cianId: activeOfferId });
    }

    dispatch(requestAuthentication({ onSuccess }));
  }, [dispatch, activeOfferId]);
};
